import { NavLink } from "react-router-dom";
import { Chip } from "@material-ui/core";
import { useDefaultTableStyling as sytlingOptions } from "./globalStyle";
import { Strings } from "../assets/res/en";
import { green, red } from "@material-ui/core/colors";
import { CheckCircle, Cancel } from "@material-ui/icons";
export default function cardholderDataColumn(classes) {
  const columns = [
    {
      render: (rowdata) => {
        let str = `${rowdata.firstName && rowdata.firstName + " "}${
          rowdata.middleName && rowdata.middleName + " "
        }${rowdata.lastName && rowdata.lastName + " "}`;
        return (
          <NavLink
            to={`/cardholders/${rowdata.idCardholder}`}
            className={classes.menuLinkPrimary}
          >
            {str.replace("null", "")}
          </NavLink>
        );
      },
      title: Strings.COLUMN_CARD_FULLNAME,
      field: "firstName",
    },
    {
      title: Strings.COLUMN_CARD_NUMBER,
      field: "cardNumber",
      disableClick: "true",
      sorting: false,
    },
    {
      title: Strings.COLUMN_CARD_TELEPHONE,
      field: "phoneNumber",
      disableClick: "true",
    },
    {
      title: Strings.COLUMN_DOB,
      field: "dateOfBirth",
      disableClick: "true",
      type: "date",
    },
    {
      title: Strings.COLUMN_GROUP,
      field: "groupDescription",
      disableClick: "true",
    },
    { title: Strings.COLUMN_LOCATION, field: "merchant", disableClick: "true" },
  ];
  const transcationOpenColumns = [
    { title: Strings.DATE, field: "requestDate", type: "datetime" },
    {
      title: Strings.STATUS,
      field: "approved",
      render: (rowdata) =>
        rowdata.approved === true ? (
          <Chip
            variant="outlined"
            size="small"
            icon={<CheckCircle style={{ color: green[500] }} />}
            label={Strings.APPROVED}
          />
        ) : (
          <Chip
            variant="outlined"
            size="small"
            icon={<Cancel style={{ color: red[500] }} />}
            label={Strings.REJECTED}
          />
        ),
    },
    { title: Strings.AMOUNT, field: "affectedInOpenLoop", type: "currency" },
  ];
  const transcationCloseColumns = [
    { title: Strings.DATE, field: "requestDate", type: "datetime" },
    {
      title: Strings.STATUS,
      field: "approved",
      render: (rowdata) =>
        rowdata.approved === true ? (
          <Chip
            variant="outlined"
            size="small"
            icon={<CheckCircle style={{ color: green[500] }} />}
            label={Strings.APPROVED}
          />
        ) : (
          <Chip
            variant="outlined"
            size="small"
            icon={<Cancel style={{ color: red[500] }} />}
            label={Strings.REJECTED}
          />
        ),
    },
    { title: Strings.AMOUNT, field: "affectedInClosedLoop", type: "currency" },
  ];
  const transcationColumnsOBInner = [
    {
      title: Strings.CARD_DESCRIPTION,
      field: "transTypeDescription",
      cellStyle: { minWidth: 200 },
      headerStyle: { minWidth: 200 },
    },
    {
      title: Strings.STATUS,
      field: "approved",
      cellStyle: { width: 25 },
      headerStyle: { width: 25 },
      render: (rowdata) =>
        rowdata.approved === true ? (
          <Chip
            variant="outlined"
            size="small"
            icon={<CheckCircle style={{ color: green[500] }} />}
            label={Strings.APPROVED}
          />
        ) : (
          <Chip
            variant="outlined"
            size="small"
            icon={<Cancel style={{ color: red[500] }} />}
            label={Strings.REJECTED}
          />
        ),
    },
    {
      title: Strings.AMOUNT,
      field: "affectedInOpenLoop",
      type: "currency",
      cellStyle: { width: 25 },
      headerStyle: { width: 25 },
    },
  ];
  const transcationColumnsCBInner = [
    {
      title: Strings.CARD_DESCRIPTION,
      field: "transTypeDescription",
      cellStyle: { minWidth: 200 },
      headerStyle: { minWidth: 200 },
    },
    {
      title: Strings.STATUS,
      field: "approved",
      cellStyle: { width: 25 },
      headerStyle: { width: 25 },
      render: (rowdata) =>
        rowdata.approved === true ? (
          <Chip
            variant="outlined"
            size="small"
            icon={<CheckCircle style={{ color: green[500] }} />}
            label={Strings.APPROVED}
          />
        ) : (
          <Chip
            variant="outlined"
            size="small"
            icon={<Cancel style={{ color: red[500] }} />}
            label={Strings.REJECTED}
          />
        ),
    },
    {
      title: Strings.AMOUNT,
      field: "affectedInClosedLoop",
      type: "currency",
      cellStyle: { width: 25 },
      headerStyle: { width: 25 },
    },
  ];
  const transStylingOption = {
    ...sytlingOptions,
    showTitle: false,
    search: false,
    toolbar: false,
    pageSize: 5,
    pageSizeOptions: [5],
    padding: "dense",
  };
  return {
    columns,
    sytlingOptions,
    transStylingOption,
    transcationOpenColumns,
    transcationCloseColumns,
    transcationColumnsOBInner,
    transcationColumnsCBInner,
  };
}